<template>
  <KTPortlet title="Мои Заказы">
    <div slot="body">
      <v-data-table :headers="fields" :items="orders" :items-per-page="15">
        <template v-slot:item.order.date="data">{{formatDateTime(data.item.order.date)}}</template>
        <template
          v-slot:item.units="data"
        >{{data.item.units}} {{data.item.measure_unit.name.toLowerCase()}}</template>
        <template
          v-slot:item.price_by_unit="data"
        >{{data.item.price_by_unit}} за {{data.item.measure_unit.name.toLowerCase()}}</template>
        <template v-slot:item.client_payment="data">
           <span
            class="badge badge-success badge-inline"
            v-if="data.item.order.payment_type == 'non_cash'"
            >Безналичный</span
          >
          <span class="badge badge-info badge-inline" v-else>Наличными</span>
        </template>
        <template v-slot:item.commission="data">
          {{data.item.commission}}
          <template v-if="data.item.commission_type == 'percent'">%</template>
        </template>
        <template
          v-slot:item.order.client="data"
        >{{data.item.order.client.name}} <a :href="`tel:${data.item.order.client.phone}`">{{data.item.order.client.phone}}</a></template>
        <template
          v-slot:item.order.dispatcher="data"
        >{{data.item.order.dispatcher.name}} <a :href="`tel:${data.item.order.dispatcher.phone}`">{{data.item.order.dispatcher.phone}}</a></template>
      </v-data-table>
    </div>
  </KTPortlet>
</template>

<script>
import KTPortlet from "@/view/content/Card.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import moment from "moment";
moment.locale("ru");

export default {
  name: "ActiveOrders",
  metaInfo: {
    title: "Мои Заказы"
  },
  components: { KTPortlet },
  data() {
    return {
      loading: false,
      orders: [],
      fields: [
        {
          value: "vehicle_type.name",
          text: "Тип"
        },
        {
          value: "order.canonical_id",
          text: "№ заказа"
        },
        {
          value: "order.date",
          text: "Дата"
        },
        {
          value: "order.address",
          text: "Адрес"
        },
        {
          value: "units",
          text: "Примерно"
        },
        {
          value: "price_by_unit",
          text: "Стоимость"
        },
        {
          value: "client_payment",
          text: "Оплата"
        },
        {
          value: "commission",
          text: "Комиссия"
        },
        {
          value: "order.description",
          text: "Доп. инфо"
        },
        {
          value: "order.client",
          text: "Заказчик"
        },
        {
          value: "order.responsible_person",
          text: "Отв. лицо"
        },
        {
          value: "order.dispatcher",
          text: "Диспетчер"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Мои Заказы" }]);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$api["contractor/orders"]
        .selectActive()
        .then(response => {
          this.orders = response.data.items;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDateTime(time) {
      return moment(time).format("dddd DD MMMM YYYY к h:mm");
    }
  }
};
</script>
